<footer class="footer">
    <div class="container">
        <div class="content">
            <div class="menu-groups" *ngIf="navigationService.footerMenu$ | async as footerMenu">
                <app-footer-group
                    [headline]="footerMenu.headlineColumn1"
                    [firstLinkBold]="true"
                    [links]="footerMenu.linksColumn1"
                ></app-footer-group>
                <app-footer-group
                    [headline]="footerMenu.headlineColumn2"
                    [links]="footerMenu.linksColumn2"
                ></app-footer-group>
                <app-footer-group
                    [headline]="footerMenu.headlineColumn3"
                    [links]="footerMenu.linksColumn3"
                ></app-footer-group>
                <app-footer-group [headline]="footerMenu.headlineColumn4" [links]="footerMenu.linksColumn4">
                    <div class="menu-group-social">
                        <app-footer-social-group
                            *ngIf="(settingsService.settings$ | async)?.footerContent as footerContent"
                            [links]="{
                                linkInstagram: footerContent?.linkInstagram,
                                linkFacebook: footerContent?.linkFacebook,
                                linkLinkedin: footerContent?.linkLinkedin,
                                linkYoutube: footerContent?.linkYoutube
                            }"
                        ></app-footer-social-group>
                    </div>
                </app-footer-group>
            </div>

            <hr class="d-none d-lg-block" />
            <div class="section section-last">
                <ng-container *ngIf="(settingsService.settings$ | async)?.footerContent as footerContent">
                    <div class="payment-options" *ngIf="footerContent?.paymentOptions?.length">
                        <div class="payment-option" *ngFor="let image of footerContent.paymentOptions">
                            <app-image [image]="image" [height]="35" [crop]="'max'"></app-image>
                        </div>
                    </div>

                    <div class="menu-group-social d-block d-lg-none">
                        <app-footer-social-group
                            [links]="{
                                linkInstagram: footerContent?.linkInstagram,
                                linkFacebook: footerContent?.linkFacebook,
                                linkLinkedin: footerContent?.linkLinkedin,
                                linkYoutube: footerContent?.linkYoutube
                            }"
                        ></app-footer-social-group>
                    </div>
                </ng-container>

                <app-trust-pilot></app-trust-pilot>
            </div>

            <div class="section section-last shop-information text-semibold ">Kop & Kande Web ApS | CVR: 32153763</div>
        </div>
    </div>

    @defer (on immediate) {
        <app-zendesk-button></app-zendesk-button>
    } @placeholder {
    <div class="placeholder"></div>
}

    <app-login-panel-trigger></app-login-panel-trigger>
</footer>
